import { HttpClient } from '../../../api/httpClient'
import apiHeaders from '../../../api/apiHeaders'

const SSO_API = `${process.env.REACT_APP_STORE_URL}/api/v1/ssoMicrosoft`

const toggleMicrosoftSso = (micSso, storeId) => {
  return HttpClient.put(
    `${SSO_API}/${micSso.id}/update?store_id=${storeId}`,
    micSso,
    apiHeaders()
  )
}

const getSecureUrl = (storeId) => {
  return HttpClient.get(
    `${process.env.REACT_APP_STORE_URL}/auth/sso/microsoft/secure-connect-url?store_id=${storeId}`,
    apiHeaders()
  )
}

const disconnectMicrosoft = (micSsoId, storeId) => {
  return HttpClient.delete(
    `${SSO_API}/${micSsoId}/disconnect?store_id=${storeId}`,
    apiHeaders()
  )
}

const SsoMicrosoftApi = { toggleMicrosoftSso, getSecureUrl, disconnectMicrosoft }

export { SsoMicrosoftApi }
